var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"size":"sm","variant":_vm.variant,"title":_vm.showToolTip ? _vm.tooltip : ''},on:{"click":_vm.addFile}},[_c('i',{class:_vm.icon}),_vm._v(_vm._s(_vm.text === null ? '' : ' ' + _vm.text)+" "),_c('input',{ref:"uploader",staticClass:"d-none",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.onFileChanged}})])
}
var staticRenderFns = []

export { render, staticRenderFns }